/**
 * @fileoverview Default form values for the Register multi-step form.
 * @module pages/register/registerInitialValues
 */

export const REGISTER_INITIAL_VALUES = {
  firstName: "",
  lastName: "",
  correoElectronicoPrincipal: "",
  codigoPais: "",
  telefonoDeOficina: "",
  password: "",
  confirmPassword: "",
  showPassword: false,
  showConfirmPassword: false,
  RFC: "",
  esExtranjero: false,
  taxId: "",
  razonSocial: "",
  nombreComercial: "",
  sectorEconomico: "",
  subSectorSCIAN: "",
  ramaSCIAN: "",
  calle: "",
  numeroExterior: "",
  numeroInterior: "",
  pais: "",
  estado: "",
  municipio: "",
  colonia: "",
  codigoPostal: "",
};
